import React, { useContext, useRef } from "react";
import { hasDimensions } from "../../services/CabinetValidator";
import { InteriorImageDragHandler, ProperSvgElement } from "./InteriorImageDragHandler";
import { InteriorImageFront } from "./InteriorImageFront";
import "./InteriorImage.scss";
import { EditorContext } from "../EditorCommon/EditorContext";
import { InterGableRulers } from "../DoorEditor/InterGableRulers";
import { ImageOutline } from "../EditorCommon/ImageOutline";
import { InteriorImageTop } from "./InteriorImageTop";
import { boundingBoxO2, moveObj } from "../../models/IObj";
import { GableWidthRulers } from "../DoorEditor/GableWidthRulers";


type SvgProps = React.SVGProps<SVGSVGElement>;

type OverriddenSvgProps = Pick<SvgProps, "xmlns" | "xmlnsXlink" | "viewBox">;
type NonOverriddenSvgProperties = Omit<SvgProps, keyof OverriddenSvgProps>;


export function InteriorImage(props: NonOverriddenSvgProperties & {
    displayHelpTextOnEmpty: boolean,
    className?: string
}) {

    const {
        displayHelpTextOnEmpty,
        className,
        ...rest
    } = props;

    const ec = useContext(EditorContext);

    const svgCanvas = useRef<SVGSVGElement>(null);
    if (!hasDimensions(ec.cabinet))
        throw new Error("dimensions not defined");


    const paddingBetweenImages = 70;

    const topImageOffset = { x: 0, y: ec.cabinet.height + (150) };
    const baseTopImageBounds = InteriorImageTop.boundingBox(ec);
    const topImageBounds = moveObj(baseTopImageBounds, topImageOffset);
    const topImage = (
        <g transform={`translate( ${topImageOffset.x} ${topImageOffset.y} )`}>
            <InteriorImageTop />
        </g>
    );
    const frontImageBounds = InteriorImageFront.boundingBox(ec);
    const imageBounds = boundingBoxO2(
        frontImageBounds,
        topImageBounds);

    return (
        <svg {...rest}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={`interior-image ${className ?? ''}`}
            preserveAspectRatio="xMidYMin meet"
            ref={svgCanvas}
            viewBox={`${imageBounds.position.x} ${imageBounds.position.y} ${imageBounds.size.x} ${imageBounds.size.y}`}>

            <InteriorImageDragHandler svgCanvas={svgCanvas.current as ProperSvgElement}>
                <rect x={0} width={ec.cabinet.width} y={0} height={ec.cabinet.height} {...ImageOutline} />
                <InteriorImageFront displayHelpTextOnEmpty={displayHelpTextOnEmpty} />
            </InteriorImageDragHandler>

            <g transform={`translate( 0 ${ec.cabinet.height + paddingBetweenImages} )`} >
                <InterGableRulers y={0} />
                <GableWidthRulers />
            </g>

            {topImage}
        </svg>
    );
}
